import { render, staticRenderFns } from "./IntegrationsInviteMethod.vue?vue&type=template&id=041fdd50&"
import script from "./IntegrationsInviteMethod.vue?vue&type=script&lang=js&"
export * from "./IntegrationsInviteMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsInviteMethod.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsInviteMethod.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
